'use client';
import React, { createContext, FC, useContext } from 'react';

import { TabsProviderProps, TabTitleContextType } from './tabs.types';

const TabTitleContext = createContext<TabTitleContextType>({
  selectedTabTitle: '',
});

export const useTabTitleContext = () => useContext(TabTitleContext);

export const TabsProvider: FC<TabsProviderProps> = ({ children, value }) => {
  return (
    <TabTitleContext.Provider value={value}>
      {children}
    </TabTitleContext.Provider>
  );
};
